import { useState, useMemo } from 'react';
import { useMount } from './useMount';
import { debounce } from 'lodash';
import { isOnMobile } from '../../language/browser';


interface WindowDimensions {
  innerWidth: number;
  innerHeight: number;
  outerWidth: number;
  outerHeight: number;
  isMobile: boolean;
}


const getWindowSize = (): WindowDimensions => ({
  innerWidth:  window.innerWidth,
  innerHeight: window.innerHeight,
  outerWidth:  window.outerWidth,
  outerHeight: window.outerHeight,
  isMobile:    isOnMobile(window),
});

/**
 * useWindowSize
 *
 * A hook that provides information of the dimensions of the window
 *
 * @return {WindowDimensions}  Dimensions of the window
 */
export const useWindowSize = (): WindowDimensions => {
  const [windowSize, setWindowSize] = useState<WindowDimensions>(getWindowSize());

  const updateDimens = useMemo(
    () => debounce(
      () => setWindowSize(getWindowSize()),
      500, // max 1 event per N ms
    ),
    [setWindowSize],
  );

  useMount(updateDimens);

  useMount(
    () => {
      window.addEventListener('resize', updateDimens);

      return () => {
        window.removeEventListener('resize', updateDimens);
      };
    },
  );

  return windowSize;
};
